<template>
    <div v-html="this.gmoPageStore.gmoPage"></div>
</template>

<script>
import { useGmoPageStore } from '@/store/gmoPage'
export default {
  computed: {
    gmoPageStore: function () {
      return useGmoPageStore()
    }
  }
}
</script>

<style></style>
